function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.431,46.123l.52-.52a.315.315,0,0,0,0-.446L3.206,40.4l4.746-4.757a.315.315,0,0,0,0-.446l-.52-.52a.315.315,0,0,0-.446,0l-5.5,5.5a.315.315,0,0,0,0,.446l5.5,5.5A.315.315,0,0,0,7.431,46.123Z",
  transform: "translate(-1.394 -34.585)"
});

var SvgArrowSharp = function SvgArrowSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6.65,
    height: 11.63,
    viewBox: "0 0 6.65 11.63"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ArrowSharp.863b0992.svg";
export { SvgArrowSharp as ReactComponent };